import { render, staticRenderFns } from "./AssetsOther.vue?vue&type=template&id=d6f056d6"
import script from "./AssetsOther.vue?vue&type=script&lang=js"
export * from "./AssetsOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports